export const STORE_EXPANDED_IDS = 'STORE_EXPANDED_IDS';
export const CLEAR_EXPANDED_IDS = 'CLEAR_EXPANDED_IDS';

export const storeExpandedIds = ({ expandedIds }) => ({
  type: STORE_EXPANDED_IDS,
  payload: { expandedIds },
});

export const clearExpandedIds = () => ({ type: CLEAR_EXPANDED_IDS });
